import { AnimationClip, Object3D } from 'three';
import { hasAnimatedPose, retargetSandboxClip, stabilizeLocomotionClip } from './retarget';
export { hasAnimatedPose };
/** Shared by the sandbox and world. Preserve body proportions and bake before crossfading. */
export function prepareLocomotion(target: Object3D, clip: AnimationClip, name: string, source?: Object3D) {
  let result = source ? retargetSandboxClip(source, target, clip) : clip.clone();
  const names = new Set<string>();
  target.traverse(node => { if ((node as Object3D & { isBone?: boolean }).isBone) names.add(node.name); });
  const aliases: Record<string, string> = { Spine1: 'Spine01', Spine2: 'Spine02', Neck: 'neck' };
  result.tracks = result.tracks.filter(track => {
    const bone = track.name.split('.')[0];
    if (!names.has(bone) && names.has(aliases[bone])) track.name = track.name.replace(bone, aliases[bone]);
    return names.has(track.name.split('.')[0]) && track.name.endsWith('.quaternion');
  });
  result.name = name;
  // Only the shared fallback needs the posture correction tuned in the sandbox.
  // Same-rig Meshy clips already encode this character's posture; baking a neutral
  // head/spine over them distorts characters with different rest orientations.
  return source ? stabilizeLocomotionClip(target, result) : result;
}
